import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pega-phone-call",
  "use": "pega-phone-call-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pega-phone-call\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M28.3 23.6l-4.5-3.9c-.7-.7-1.4-.4-1.8 0l-2 2c-1.6 1.1-10.7-8-9.6-9.5l2-2.1c.4-.4.6-1.2 0-1.8L8.6 4.1s-.9-.6-1.8-.2c-.7.4-3.7 2.8-2.8 7.9.9 5.7 10.9 15.7 16.5 16.5 5.1.8 7.4-2 7.9-2.9.4-.8-.1-1.8-.1-1.8z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol